import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import BlockUi from 'react-block-ui';
import { connect } from 'react-redux';
import { Loader } from 'react-loaders';
import { Link, Redirect } from 'react-router-dom';
import { isAccess } from '../../shared/index';

import { postSubScoringGroupDetails } from '@redux/metadata-manager/data-scoring/actions';
import { ViewGroupDetailsSelector } from '@redux/metadata-manager/data-scoring/selectors';

import BackIcon from '@static/images/back-icon.svg';
import BreadcrumbIcon from '@static/images/breadcrumb-icon.svg';

import { handleResponse } from '../../shared/index';

import Table from './table';
import { METADATA_SUB_GROPUP_SCORING_COLUMNS } from './columns';
import EditScoringDetails from '../edit-scoring-details';

const ScoringSubGroupDetails = ({
  subGroupDetailsData,
  location,
  handlePostSubScoringGroupDetails
}) => {
  const { state } = location;

  const formObject = state?.formObject;
  const listOfSegmentTypesList = state?.listOfSegmentTypesList;
  const payload = state?.payload;
  const isEditableAccess = isAccess(
    state?.formObject?.year,
    state?.dataDomainName
  );

  const [redirect, setRedirect] = useState(false);
  const [redirectValue, setRedirectValue] = useState();
  const [selectedRow, setSelectedRow] = useState({});
  const [isloading, setIsloading] = useState('');

  const handleSubScoringGroupDetailsAPI = async () => {
    setIsloading(true);
    try {
      const response = await handlePostSubScoringGroupDetails(payload);
      const result = handleResponse(response);
      if (result?.isSuccess) {
        setIsloading(false);
      }
      setIsloading(false);
    } finally {
      setIsloading(false);
    }
  };

  useEffect(() => {
    handleSubScoringGroupDetailsAPI();
    window.scrollTo(0, 0);
  }, []);

  const handleEditScoringDetails = item => {
    setSelectedRow(item.row.original);
  };

  const handleBackBtn = () => {
    setRedirectValue('/metadata-manager/data-scoring');
    setRedirect(true);
  };

  return (
    <BlockUi
      blocking={isloading}
      message="Loading, please wait"
      loader={<Loader active type="semi-circle-spin" />}
    >
      <div className="ymca-wrapper manage-metadata-page">
        <main className="page-container">
          <div className="container">
            <div className="d-flex justify-content-between">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb ymca-breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/metadata-manager/dashboard">
                      <span>Dashboard</span>
                    </Link>
                    <img
                      src={BreadcrumbIcon}
                      className="breadcrumb-icon"
                      alt=""
                    />
                  </li>
                  <li className="breadcrumb-item active">
                    <Link to="/metadata-manager/data-scoring">
                      <span> Data Scoring Metadata</span>
                    </Link>
                    <img
                      src={BreadcrumbIcon}
                      className="breadcrumb-icon"
                      alt=""
                    />
                  </li>
                  <li className="breadcrumb-item active">Sub Group Details</li>
                </ol>
              </nav>
              <Link
                className="ymca-title-link"
                to="/metadata-manager/data-scoring"
              >
                <img src={BackIcon} className="me-1 mb-2" alt="back-icon" />
                {''}
                Back{}
              </Link>
            </div>
            <h5 className="ymca-sub-heading mb-0">Sub Group Details</h5>
          </div>
          <hr />
          <Table
            rows={subGroupDetailsData?.data}
            headers={METADATA_SUB_GROPUP_SCORING_COLUMNS({
              handleEditScoringDetails,
              isEditableAccess
            })}
          />
        </main>
      </div>

      <EditScoringDetails
        row={selectedRow}
        formObject={formObject}
        listOfSegmentTypes={listOfSegmentTypesList}
        handleBackBtn={handleBackBtn}
        handleSubScoringGroupDetailsAPI={handleSubScoringGroupDetailsAPI}
      />

      {redirect && <Redirect to={redirectValue} />}
    </BlockUi>
  );
};

ScoringSubGroupDetails.propTypes = {
  subGroupDetailsData: PropTypes.arrayOf(PropTypes.any),
  location: PropTypes.objectOf(PropTypes.any),
  handlePostSubScoringGroupDetails: PropTypes.func.isRequired
};

ScoringSubGroupDetails.defaultProps = {
  subGroupDetailsData: [],
  location: []
};

const mapDispatchToProps = {
  handlePostSubScoringGroupDetails: postSubScoringGroupDetails
};

const mapStateToProps = state => ({
  subGroupDetailsData: ViewGroupDetailsSelector(state)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ScoringSubGroupDetails);
